module.exports = __webpack_public_path__ + "img/2_E.a5dc12a7.png";